import { _ as d, d as f } from "./CSSMotionList.js";
import * as n from "react";
function I() {
  var t = d({}, n);
  return t.useId;
}
var u = 0, a = I();
const v = a ? (
  // Use React `useId`
  function(e) {
    var r = a();
    return e || (process.env.NODE_ENV === "test" ? "test-id" : r);
  }
) : (
  // Use compatible of `useId`
  function(e) {
    var r = n.useState("ssr-id"), s = f(r, 2), c = s[0], i = s[1];
    return n.useEffect(function() {
      var o = u;
      u += 1, i("rc_unique_".concat(o));
    }, []), e || (process.env.NODE_ENV === "test" ? "test-id" : c);
  }
);
export {
  v as u
};
